import { gql } from 'graphql-request'

export const USUARIO_EDICAO_SECOND_PAGE_QUERY = gql`
  query usuarioEdicaoSecondPageQuery($idsDealer: [ID], $tipoUsuario: ID!) {
    produtosByDealersAndTipoUsuario(
      idsDealer: $idsDealer
      tipoUsuario: $tipoUsuario
    ) {
      id
      nome
      tiposAcesso {
        id
        nome
        funcionalidadesPadrao {
          id
        }
      }
      funcionalidades {
        id
        nome
        descricao
        tiposAcesso {
          id
          nome
        }
      }
    }
  }
`
